import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

import {fuseAnimations} from '@fuse/animations';
import {IRepresentativeVoteDataResponse} from '../../../../../shared/models/partipant.model';

@Component({
    selector: 'sip-representative-vote-hash-dialog',
    templateUrl: './representative-vote-hash-dialog.component.html',
    animations: fuseAnimations
})
export class RepresentativeVoteHashDialogComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<RepresentativeVoteHashDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: IRepresentativeVoteDataResponse[]) {
    }

    ngOnInit(): void {
        setTimeout(() => {
            this.dialogRef.close();
        }, 8000);
    }
}
